// node_modules
import { 
    FC
} from "react";
// Components
import { MarkdownItComponent } from "Components/Shared";

import styles from "./youtubeVideo.module.scss";

type TYoutubeVideoProps = {
    caption: string,
    link: string
}

export const YoutubeVideo: FC<TYoutubeVideoProps> = ({caption, link}: TYoutubeVideoProps) => {
    return (
        <div className={styles.youtubeContainerWrapper}>
            <div className={styles.youtubeVideoContainer}>
                <iframe title="Embedded youtube video" className={styles.youtubeFrame} src={link} frameBorder="0" allowFullScreen></iframe>
            </div>
            <MarkdownItComponent source={caption} noSource={" "} />
        </div>
    );
};
